// Influencer API Service
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1'

class InfluencerService {
  constructor() {
    this.baseURL = API_BASE_URL
  }

  // Check if an applicant already exists
  async checkApplicant(email, phoneNumber, fullName) {
    try {
      const response = await fetch(`${this.baseURL}/check-applicant`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email.toLowerCase(),
          phone_number: phoneNumber,
          full_name: fullName
        })
      })

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}))
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error checking applicant:', error)
      throw error
    }
  }

  // Submit a new influencer application
  async submitApplication(applicationData) {
    try {
      const payload = {
        email: applicationData.email.toLowerCase(),
        phone_number: applicationData.phone,
        full_name: applicationData.full_name,
        twitter: applicationData.twitter || null,
        instagram: applicationData.instagram || null,
        tiktok: applicationData.tiktok || null
      }

      const response = await fetch(`${this.baseURL}/influencer-apply`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      })

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}))
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error submitting application:', error)
      throw error
    }
  }

  // Get influencer by email
  async getInfluencer(email) {
    try {
      const response = await fetch(`${this.baseURL}/influencer/${encodeURIComponent(email.toLowerCase())}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}))
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error getting influencer:', error)
      throw error
    }
  }

  // Get influencer profile with additional stats (total_payouts, est_next_payout, num_active_subs)
  async getInfluencerProfile(email) {
    try {
      const response = await fetch(`${this.baseURL}/influencer/profile/${encodeURIComponent(email.toLowerCase())}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}))
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('Error getting influencer profile:', error)
      throw error
    }
  }


}

export const influencerService = new InfluencerService() 